import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Card, CardBody, CardGroup, Col, Container, Row } from 'reactstrap';
import LoginForm from './forms/LoginForm';
import ListErrors from './ListErrors';
import agent from '../agent';

import {
    UPDATE_FIELD_AUTH,
    LOGIN,
    COMPONENT_UNLOAD,
    API_ROOT,
    S3_ROOT,
    COMMON_UPDATE_FILTER
} from '../constants/actionTypes';

const mapStateToProps = state => ({
    ...state.auth,
    companyName: state.common.companyName,
    loginLogoURL: state.common.loginLogoURL,
});

const mapDispatchToProps = dispatch => ({
    onChangeUsername: value =>
        dispatch({ type: UPDATE_FIELD_AUTH, key: 'username', value }),
    onChangePassword: value =>
        dispatch({ type: UPDATE_FIELD_AUTH, key: 'password', value }),
    onSubmit: (username, password) => 
        dispatch({ type: LOGIN, payload: agent.Authorization.login(username, password) }),
    onUnload: () =>
        dispatch({ type: COMPONENT_UNLOAD }),
    onUpdateFilter: (key, value) =>
        dispatch({ type: COMMON_UPDATE_FILTER, key, value })
});

function getElementValueByKey(array, key, value) {
    return array.filter(function (object) {
        return object[key] === value;
    });
}

function getValueByKey(array, key, value) {
    let valueArray = getElementValueByKey(array, key, value);

    if (valueArray.length > 0) {
        return valueArray[0].value;
    } else {
        return null;
    }
}

class Login extends Component {
    constructor() {
        super();

        this.loadData = this.loadData.bind(this);

        this.changeUsername = ev => this.props.onChangeUsername(ev.target.value);
        this.changePassword = ev => this.props.onChangePassword(ev.target.value);
        this.submitForm = (username, password) => ev => {
            ev.preventDefault();
            this.props.onSubmit(username, password);
        };
    }

    componentWillMount() {
        this.loadData();
    }

    componentWillUnmount() {
        this.props.onUnload();
    }

    loadData() {
        const settingsRequest = {
            "blockgroup": "Administrative Settings::Theme and Logos",
            "recordtitle": "Default Theme",
            "blockpaths": [
                "dashboardTemplate::headerLogoPC",
                "dashboardTemplate::headerLogoMobile",
                "dashboardTemplate::footerLeft",
                "dashboardTemplate::footerRight",
                "systemDefaults::companyName",
                "systemDefaults::loginLogo",
                "systemDefaults::headerLogo",                
            ]
        }

        fetch(`${API_ROOT}/BlockDataValueExtended`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(settingsRequest)
        }).then(
            response => response.json()
        ).then(data => {
            if (data.hasOwnProperty('fieldsetdata')) {
                let fieldsetdata = data.fieldsetdata;
                for (var i = 0; i < fieldsetdata.length; i++) {
                    switch (fieldsetdata[i].blockpath) {
                        case "dashboardTemplate::headerLogoPC":
                            let headerLogoPC = getValueByKey(fieldsetdata[i].elementdata, 'key', 'CMSImageURL');
                            this.props.onUpdateFilter('headerLogoPC', `${S3_ROOT}${headerLogoPC}`);
                            break;
                        case "dashboardTemplate::headerLogoMobile":
                            let headerLogoMobile = getValueByKey(fieldsetdata[i].elementdata, 'key', 'CMSImageURL');
                            this.props.onUpdateFilter('headerLogoMobile', `${S3_ROOT}${headerLogoMobile}`);
                            break;
                        case "dashboardTemplate::footerLeft":
                            let footerLeft = fieldsetdata[i].value;
                            this.props.onUpdateFilter('footerLeft', footerLeft);
                            break;
                        case "dashboardTemplate::footerRight":
                            let footerRight = fieldsetdata[i].value;
                            this.props.onUpdateFilter('footerRight', footerRight);
                            break;
                        case 'systemDefaults::companyName':
                            let companyName = fieldsetdata[i].value;
                            this.props.onUpdateFilter('companyName', companyName);
                            break;
                        case 'systemDefaults::loginLogo':
                            let loginLogoURL = getValueByKey(fieldsetdata[i].elementdata, 'key', 'CMSImageURL');
                            this.props.onUpdateFilter('loginLogoURL', `${S3_ROOT}${loginLogoURL}`);
                            break;
                        case "systemDefaults::headerLogo":
                            let headerLogo = getValueByKey(fieldsetdata[i].elementdata, 'key', 'CMSImageURL');
                            this.props.onUpdateFilter('headerLogo', `${S3_ROOT}${headerLogo}`);
                            break;
                        default:
                            break;
                    }
                }
            }
        });
    }

    

    render() {
        const username = this.props.username || '';
        const password = this.props.password || '';
        const companyName = this.props.companyName || '';
        const loginLogoURL = <img src={this.props.loginLogoURL} alt={companyName} style={{"maxHeight": "100px"}} /> || '';

        return (
            <div className="app flex-row align-items-center">
                <Container>
                    <Row className="justify-content-center">
                        <Col md="8">
                            <CardGroup>
                                <Card className="p-4">
                                    <CardBody>
                                        <ListErrors errors={this.props.errors} />

                                        <LoginForm handleSubmit={this.submitForm(username, password)} changeUsername={this.changeUsername} changePassword={this.changePassword} username={username} password={password} />
                                    </CardBody>
                                </Card>
                                <Card className="text-white bg-primary py-5 d-md-down-none" style={{ width: 44 + '%' }}>
                                    <CardBody className="text-center">
                                        <div>
                                            <div md="4">{loginLogoURL}</div>
                                            <h2>{companyName}</h2>

                                            <Button color="primary" className="mt-3" active href="/Register">Register New Account</Button>
                                        </div>
                                    </CardBody>
                                </Card>
                            </CardGroup>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default (connect(mapStateToProps, mapDispatchToProps)(Login));


// WEBPACK FOOTER //
// ./src/containers/Login.js